import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * `enableResourceBookingNativeFloorplan` swaps the Archilogic floorplan for the
 * natively rendered one (admin-authored image + resource placements).
 */
export const useIsNativeFloorplanEnabled = (): boolean => {
  const { enableResourceBookingNativeFloorplan } = useFlags();

  return Boolean(enableResourceBookingNativeFloorplan);
};
